import { CrudService } from "./crud.service";
import LocalStorageKeys from "../data/localStorageKeys";

export class PagoService extends CrudService {

    get AuthHeader() {
        return "Bearer " + localStorage.getItem(LocalStorageKeys.tokenComercio);
    }

    constructor() {
        super('pago/');
    }
}